export function isDefined<TValue>(value: TValue | null | undefined): value is TValue {
    return typeof value === 'object' ? !!value && !!Object.keys(value).length : value !== null && value !== undefined;
}
